export default {"src":"/_next/static/media/customer-service-inverse.1331ff8b.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};